<template>
  <div class="create-advert">
    <error :errors="navigationError" />
    <navigation-form action="edit" />
  </div>
</template>

<script>
  import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
  import NavigationForm from "../../../components/forms/NavigationForm";
  import Error from "../../../partials/widgets/Error";
  import { mapGetters } from "vuex";
  export default {
    name: "index",
    components: { NavigationForm, Error },
    computed: {
      ...mapGetters(['navigationError'])
    },
    mounted() {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "باشلاش تىزىملىكى باشقۇرۇش", route: "list" },
        { title: "ئۇچۇر تەھرىرلەش" }
      ]);
    },
    data(){
      return {
        formBusy: false
      };
    },
    methods: {
    }
  }
</script>

<style scoped>

</style>
